import React, { createContext } from 'react';

export const OlsShopContext = createContext();

export function mapContextToProps(Component, getPropsFromContext) {
  return props => (
    <OlsShopContext.Consumer>
      { (context = {}) => <Component { ...props } { ...getPropsFromContext(context) } /> }
    </OlsShopContext.Consumer>
  );
}
